import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faCheckCircle} from '@fortawesome/free-solid-svg-icons'

//Start Css code ...
const useStyles = makeStyles((theme) => ({
    close: {
        padding: theme.spacing(0.5),
    },
    errorPopup: {
        
        '& .MuiSnackbar-root': {
            position: 'relative'
        },
        '& .MuiSnackbarContent-root': {
            color: '#991B1B',
            border: '1px solid #FCA5A5',
            background: '#FEF2F2',
            borderRadius: '6px',
            width: '100%',
        },
        '& .MuiSnackbarContent-message':{
            display:'flex',

        },
        '& .MuiSnackbar-anchorOriginBottomCenter' : {
            bottom:'0'
        },
        '& .MuiSnackbarContent-message' : {
            display: 'flex',
            padding:' 8px 0'
        },
    },
    successPopup: {
        
        '& .MuiSnackbar-root': {
            position: 'relative'
        },
        '& .MuiSnackbarContent-root': {
            color: ' #000',
            background: '#DFF0D8',
            border: '1px solid #006600',
            marginTop: '1%',
        },
        '& .MuiSnackbarContent-message':{
            display:'flex',
            '& span' : {
                fontSize:'11pt !important'
            }

        },
        '& .MuiSnackbar-anchorOriginBottomCenter' : {
            bottom:'0',
            zIndex: '1'
        },
        '& .MuiSnackbarContent-message' : {
            color: ' #333333',
            display: 'flex',
            padding:' 8px 0'
        }
    },
    errIcon : {
        fontSize : '20px',
        color:'#F87171'
     },
     successIcon : {
        fontSize : '20px',
        color:'#006600'
     }
}));
//End Css code ...

//Start ErrorMessage component code ...
export default function ErrorMessage(props) {
    const [open, setOpen] = React.useState(false);
    const [messageInfo, setMessageInfo] = React.useState(null);

    React.useEffect(() => {
        if (!messageInfo) {
            // Set a new snack when we don't have an active one
            setMessageInfo(props.message);
            setOpen(true);
        } else if (messageInfo && open) {
            // Close an active snack when a new one is added
            setOpen(false);
        }
    }, [props.message, props.show, props.msgType]);



    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const handleExited = () => {
        setMessageInfo(undefined);
    };

    const classes = useStyles();
    return (
        <div className={props.msgType == 'error' ? classes.errorPopup : classes.successPopup}>
            <Snackbar
                key={messageInfo ? messageInfo.key : undefined}
                open={props.show}
                onClose={props.visible}
                onExited={handleExited}
                message={messageInfo ? <> <div >
                    {props.msgType == 'error' ? <FontAwesomeIcon icon={faExclamationCircle}  className={classes.errIcon}/> : <FontAwesomeIcon icon={faCheckCircle}  className={classes.successIcon}/>} 
                </div> &nbsp; <span data-testid="errMsg">{messageInfo}</span> </> : undefined}
            />
        </div>
    );
}
//End ErrMessage component code ...
